import * as React from 'react';
import { useTheme } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { S } from '../styles';

export const CloudCodeTask: React.FC<{
  title: string;
  source: string;
  result: string;
  running: boolean;
  compact?: boolean;
  triggered?: boolean;
}> = ({ title, source, result, running, compact = false, triggered }) => {
  const theme = useTheme();
  const colors = theme.featureGraph;
  const width = compact ? 250 : 380;
  const height = compact ? 140 : 155;
  const padding = compact ? 18 : 24;
  const ringX = compact ? 210 : 324;
  const ringY = compact ? 70 : 77;
  const radius = compact ? 22 : 32;
  const iconSize = compact ? 20 : 26;
  return (
    <g>
      <rect
        width={width}
        height={height}
        rx="18"
        fill={theme.surface.background}
        stroke={colors.cloudService.border}
        strokeWidth="1.5"
      />
      <rect width={width} height={height} rx="18" fill={colors.cloudService.background} />
      <text
        x={padding}
        y="30"
        fill={colors.cloudService.accent}
        fontSize={compact ? 10 : 11}
        letterSpacing={compact ? 1.2 : 2}
      >
        CLOUDCODE TASK
      </text>
      <text x={padding} y="66" fill={theme.text.heading} fontSize={compact ? 18 : 24} fontWeight="600">
        {title}
      </text>
      <circle cx={ringX} cy={ringY} r={radius} fill="none" stroke={colors.cloudService.border} strokeWidth="2" />
      <S.TaskOrbit
        active={triggered === true}
        running={running}
        style={{ transformOrigin: `${ringX}px ${ringY}px`, transformBox: 'view-box' }}
      >
        <S.Flow
          d={`M${ringX} ${ringY - radius} A${radius} ${radius} 0 1 1 ${ringX} ${ringY + radius} A${radius} ${radius} 0 1 1 ${ringX} ${ringY - radius}`}
          running={running && triggered === undefined}
          fill="none"
          stroke={colors.cloudService.accent}
          strokeWidth="2"
          strokeLinecap="round"
          pathLength="108"
          strokeDasharray="5 22"
        />
      </S.TaskOrbit>
      <FontAwesomeIcon
        icon={faCloud}
        x={ringX - iconSize / 2}
        y={ringY - iconSize / 2}
        width={iconSize}
        height={iconSize}
        color={colors.cloudService.accent}
      />
      <text x={padding} y={height - 24} fill={theme.text.paragraph} fontSize={compact ? 12 : 15}>
        <tspan>{source}</tspan>
        <tspan dx={compact ? 8 : 12} fill={colors.cloudService.accent}>
          →
        </tspan>
        <tspan dx={compact ? 8 : 12}>{result}</tspan>
      </text>
    </g>
  );
};
